import React from "react";
import { useForm, FormProvider } from "react-hook-form";
import Form from "react-bootstrap/Form";
import { authActions } from "../../../redux/actions/auth.action";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { dateObjectToServerFormat, formatDOB, getUserPayload } from "../../../system";

const BaseBecomeVerifiedUser = ({ children }) => {
  const userData = getUserPayload();
  const methods = useForm();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { handleSubmit } = methods;

  const onSubmit = async (data) => {
    const UserVerfiedDocs = {
      documentTypeId: data.documentType,
      expiredOnString: dateObjectToServerFormat(data.expiredateString),
      documentIdentityId: data.nationalIdentity,
      documents: data.uploadImage,
      systemUserId: userData?.user?.id,
    };
    dispatch(authActions.becomeVerifiedUser(UserVerfiedDocs, navigate));
  };

  return (
    <FormProvider {...methods}>
      <Form noValidate onSubmit={handleSubmit(onSubmit)}>
        <div className="BecomeVerifiedUserBase">{children}</div>
      </Form>
    </FormProvider>
  );
};

export default BaseBecomeVerifiedUser;
